import { render, staticRenderFns } from "./AbonadosList.vue?vue&type=template&id=6913d7b6"
import script from "./AbonadosList.vue?vue&type=script&setup=true&lang=js"
export * from "./AbonadosList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports